import React, { useEffect, useMemo, useState } from 'react';
import _ from 'lodash';

function Preloader({
  course = {},
  curPage = 0,
}: {
  course?: {
    pages?: any[];
    baseURL?: string;
  };
  curPage?: number;
}) {
  type StackItem = {
    pageIdx: number;
    url: string;
  };

  const { pages = [], baseURL = '' } = course;
  const [stack, setStack] = useState<StackItem[]>([]);
  const limit = 5; // will load the next/prev N pages

  useEffect(() => {
    const initialStack: StackItem[] = [];
    _.forEach(pages, (page = {}, idx) => {
      if (page.filename)
        initialStack.push({
          pageIdx: idx,
          url: `${baseURL}/${page.filename}`,
        });
      //   if (page.audio?.name) urls.push(`${baseURL}/${page.audio?.name}`);
      //   if (page.facevideo?.name) urls.push(`${baseURL}/${page.facevideo?.name}`);
      //   if (page.video?.name) urls.push(`${baseURL}/${page.video?.name}`);
    });

    if (_.isEmpty(initialStack)) return;

    setStack(initialStack);
  }, [baseURL, pages]);

  const filteredStack = useMemo(
    () =>
      _.filter(
        stack,
        (s) =>
          s.pageIdx > curPage - (limit - 1) && s.pageIdx < curPage + (limit - 1)
      ),
    [stack, curPage]
  );

  function handleOnMediaPreloaded(src: string) {
    setStack(_.filter(stack, (s) => s.url !== src)); // remove from stack
  }

  function Media({ src, onLoad }: { src?: string; onLoad?: Function }) {
    if (!src) {
      return null;
    }
    return (
      // eslint-disable-next-line
      <img
        src={src}
        onLoad={() => {
          // console.log(`Preloading ${src}: complete!`);
          onLoad && onLoad(src);
        }}
      />
    );
  }

  return (
    <div style={{ display: 'none' }}>
      <Media src={filteredStack[0]?.url} onLoad={handleOnMediaPreloaded} />
    </div>
  );
}

export default Preloader;
